// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.landingLeftSection {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 22.8%;
  height: 100%;
}

.landingLeftSectionContainer {
  width: 94%;
  max-width: 340px;
  height: 84vh;
  max-height: 720px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
}

.authLeftTopBar {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
  width: 100%;
}

.authBackHubBtn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: rgba(255, 255, 255, 0.08);
  color: #e2e8f0;
  border: 1px solid rgba(255, 255, 255, 0.16);
  border-radius: 20px;
  padding: 7px 16px;
  font-family: "Poppins", "Inter", sans-serif;
  font-size: 12.5px;
  font-weight: 500;
  cursor: pointer;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  transition: all 0.22s ease;
  width: fit-content;
}

.authBackHubBtn:hover {
  background: rgba(90, 175, 154, 0.16);
  border-color: rgba(90, 175, 154, 0.6);
  color: #5AAF9A;
  transform: translateX(-3px);
}

.amalgamateLogoContainer {
  width: 100%;
  display: flex;
  align-items: center;
  transition: opacity 0.2s ease, transform 0.2s ease;
}

.amalgamateLogoContainer:hover {
  opacity: 0.9;
  transform: scale(1.02);
}

.authLeftSectionLogo,
.webAmalgamateLogo,
.amalgamateLogo {
  height: auto !important;
  max-height: 75px !important;
  width: 95% !important;
  max-width: 280px !important;
  object-fit: contain !important;
  display: block !important;
}

.leftSectionContentContainer {
  margin: auto 0;
  display: flex;
  flex-direction: column;
  gap: 3.5vh;
  width: 100%;
}

.leftSectionContent {
  display: flex;
  align-items: flex-start;
  gap: 14px;
}

.textContainer {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}

.contentHeading {
  font-family: "Poppins", sans-serif;
  font-weight: 600;
  line-height: 1.35;
  font-size: 19px;
  margin-bottom: 5px;
  color: #ffffff;
}

.contentTexts {
  font-family: "Poppins", sans-serif;
  font-weight: 400;
  line-height: 1.5;
  color: #b0b0b0;
  font-size: 14px;
}

.lowerSection {
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
  margin-top: 0;
}

.webGetTheAppContainer,
.getTheAppContainer {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  width: 100%;
}

.fadingLine1 {
  flex: 1 1;
  height: 1px;
  background: linear-gradient(to right, rgba(255, 255, 255, 0), #bebebe);
}

.fadingLine2 {
  flex: 1 1;
  height: 1px;
  background: linear-gradient(to right, #bebebe, rgba(255, 255, 255, 0));
}

.webGetTheAppText,
.getTheAppText {
  font-family: "Poppins", sans-serif;
  font-weight: 500;
  font-size: 13px;
  white-space: nowrap;
  color: #ffffff;
}

.downloadAppCards {
  margin-top: 16px;
  width: 100%;
}

.downloadAppCardContainer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  width: 100%;
}

.webDownloadAppCard,
.downloadAppCard {
  background-color: #ffffff;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1 1;
  min-width: 0;
  height: 50px;
  box-sizing: border-box;
  padding: 5px 8px;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  text-decoration: none;
}

.webDownloadAppCard:hover,
.downloadAppCard:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);
}

.webDownloadAppCardIcon,
.downloadAppCardIcon,
.webDownloadAppCardIcon2,
.downloadAppCardIcon2 {
  height: 22px;
  width: 22px;
  flex-shrink: 0;
  object-fit: contain;
}

.downloadAppCardTextContainer {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  margin-left: 6px;
  min-width: 0;
  flex-shrink: 0;
}

.webDownloadAppCardText1,
.downloadAppCardText1 {
  color: #444444;
  font-family: "Inter", sans-serif;
  font-size: 0.64rem;
  font-weight: 500;
  line-height: 1.1;
  white-space: nowrap;
}

.webDownloadAppCardText2,
.downloadAppCardText2 {
  color: #111111;
  font-family: "Inter", sans-serif;
  font-size: 0.82rem;
  font-weight: 700;
  line-height: 1.2;
  white-space: nowrap;
}

/* ==========================================================================
   Responsive Media Queries
   ========================================================================== */

/* Medium / Narrow Desktops and Tablets in Landscape */
@media (min-width: 769px) and (max-width: 1100px) {
  .landingLeftSection {
    width: 27%;
    min-width: 260px;
  }
  .webDownloadAppCard,
  .downloadAppCard {
    padding: 4px 6px;
  }
  .webDownloadAppCardText2,
  .downloadAppCardText2 {
    font-size: 0.76rem;
  }
}

/* Height-Constrained Laptops (e.g. 1366x768 with browser bars or scaled displays) */
@media (max-height: 720px) {
  .landingLeftSectionContainer {
    height: 90vh;
  }
  .webAmalgamateLogo,
  .amalgamateLogo {
    max-height: 60px;
  }
  .leftSectionContentContainer {
    gap: 16px;
  }
  .contentHeading {
    font-size: 17px;
    margin-bottom: 3px;
  }
  .contentTexts {
    font-size: 13px;
    line-height: 1.4;
  }
  .downloadAppCards {
    margin-top: 10px;
  }
}

/* Ultra-short screens (< 600px height) */
@media (max-height: 600px) {
  .landingLeftSectionContainer {
    height: 94vh;
  }
  .webAmalgamateLogo,
  .amalgamateLogo {
    max-height: 48px;
  }
  .leftSectionContentContainer {
    gap: 10px;
  }
  .contentHeading {
    font-size: 15px;
  }
  .contentTexts {
    font-size: 12px;
    line-height: 1.3;
  }
}

/* Mobile & Portrait Tablets */
@media (max-width: 768px) {
  .landingLeftSection {
    display: none !important;
  }
}

`, "",{"version":3,"sources":["webpack://./src/Components/Shared/AuthLeftSection/AuthLeftSection.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,qCAAqC;EACrC,cAAc;EACd,2CAA2C;EAC3C,mBAAmB;EACnB,iBAAiB;EACjB,2CAA2C;EAC3C,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,2BAA2B;EAC3B,mCAAmC;EACnC,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,qCAAqC;EACrC,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,kDAAkD;AACpD;;AAEA;EACE,YAAY;EACZ,sBAAsB;AACxB;;AAEA;;;EAGE,uBAAuB;EACvB,2BAA2B;EAC3B,qBAAqB;EACrB,2BAA2B;EAC3B,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,UAAU;EACV,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,mBAAmB;EACnB,aAAa;AACf;;AAEA;;EAEE,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,SAAO;EACP,WAAW;EACX,sEAAsE;AACxE;;AAEA;EACE,SAAO;EACP,WAAW;EACX,sEAAsE;AACxE;;AAEA;;EAEE,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,WAAW;AACb;;AAEA;;EAEE,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAW;EACX,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,qDAAqD;EACrD,qBAAqB;AACvB;;AAEA;;EAEE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;;;;EAIE,YAAY;EACZ,WAAW;EACX,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,sBAAsB;EACtB,gBAAgB;EAChB,YAAY;EACZ,cAAc;AAChB;;AAEA;;EAEE,cAAc;EACd,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;EAEE,cAAc;EACd,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;+EAE+E;;AAE/E,sDAAsD;AACtD;EACE;IACE,UAAU;IACV,gBAAgB;EAClB;EACA;;IAEE,gBAAgB;EAClB;EACA;;IAEE,kBAAkB;EACpB;AACF;;AAEA,oFAAoF;AACpF;EACE;IACE,YAAY;EACd;EACA;;IAEE,gBAAgB;EAClB;EACA;IACE,SAAS;EACX;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;AACF;;AAEA,yCAAyC;AACzC;EACE;IACE,YAAY;EACd;EACA;;IAEE,gBAAgB;EAClB;EACA;IACE,SAAS;EACX;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA,8BAA8B;AAC9B;EACE;IACE,wBAAwB;EAC1B;AACF","sourcesContent":[".landingLeftSection {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 22.8%;\n  height: 100%;\n}\n\n.landingLeftSectionContainer {\n  width: 94%;\n  max-width: 340px;\n  height: 84vh;\n  max-height: 720px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: flex-start;\n}\n\n.authLeftTopBar {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 12px;\n  width: 100%;\n}\n\n.authBackHubBtn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  background: rgba(255, 255, 255, 0.08);\n  color: #e2e8f0;\n  border: 1px solid rgba(255, 255, 255, 0.16);\n  border-radius: 20px;\n  padding: 7px 16px;\n  font-family: \"Poppins\", \"Inter\", sans-serif;\n  font-size: 12.5px;\n  font-weight: 500;\n  cursor: pointer;\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n  transition: all 0.22s ease;\n  width: fit-content;\n}\n\n.authBackHubBtn:hover {\n  background: rgba(90, 175, 154, 0.16);\n  border-color: rgba(90, 175, 154, 0.6);\n  color: #5AAF9A;\n  transform: translateX(-3px);\n}\n\n.amalgamateLogoContainer {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  transition: opacity 0.2s ease, transform 0.2s ease;\n}\n\n.amalgamateLogoContainer:hover {\n  opacity: 0.9;\n  transform: scale(1.02);\n}\n\n.authLeftSectionLogo,\n.webAmalgamateLogo,\n.amalgamateLogo {\n  height: auto !important;\n  max-height: 75px !important;\n  width: 95% !important;\n  max-width: 280px !important;\n  object-fit: contain !important;\n  display: block !important;\n}\n\n.leftSectionContentContainer {\n  margin: auto 0;\n  display: flex;\n  flex-direction: column;\n  gap: 3.5vh;\n  width: 100%;\n}\n\n.leftSectionContent {\n  display: flex;\n  align-items: flex-start;\n  gap: 14px;\n}\n\n.textContainer {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n}\n\n.contentHeading {\n  font-family: \"Poppins\", sans-serif;\n  font-weight: 600;\n  line-height: 1.35;\n  font-size: 19px;\n  margin-bottom: 5px;\n  color: #ffffff;\n}\n\n.contentTexts {\n  font-family: \"Poppins\", sans-serif;\n  font-weight: 400;\n  line-height: 1.5;\n  color: #b0b0b0;\n  font-size: 14px;\n}\n\n.lowerSection {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  align-items: center;\n  margin-top: 0;\n}\n\n.webGetTheAppContainer,\n.getTheAppContainer {\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  gap: 12px;\n  width: 100%;\n}\n\n.fadingLine1 {\n  flex: 1;\n  height: 1px;\n  background: linear-gradient(to right, rgba(255, 255, 255, 0), #bebebe);\n}\n\n.fadingLine2 {\n  flex: 1;\n  height: 1px;\n  background: linear-gradient(to right, #bebebe, rgba(255, 255, 255, 0));\n}\n\n.webGetTheAppText,\n.getTheAppText {\n  font-family: \"Poppins\", sans-serif;\n  font-weight: 500;\n  font-size: 13px;\n  white-space: nowrap;\n  color: #ffffff;\n}\n\n.downloadAppCards {\n  margin-top: 16px;\n  width: 100%;\n}\n\n.downloadAppCardContainer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  width: 100%;\n}\n\n.webDownloadAppCard,\n.downloadAppCard {\n  background-color: #ffffff;\n  border-radius: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex: 1 1 0;\n  min-width: 0;\n  height: 50px;\n  box-sizing: border-box;\n  padding: 5px 8px;\n  cursor: pointer;\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\n  text-decoration: none;\n}\n\n.webDownloadAppCard:hover,\n.downloadAppCard:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);\n}\n\n.webDownloadAppCardIcon,\n.downloadAppCardIcon,\n.webDownloadAppCardIcon2,\n.downloadAppCardIcon2 {\n  height: 22px;\n  width: 22px;\n  flex-shrink: 0;\n  object-fit: contain;\n}\n\n.downloadAppCardTextContainer {\n  display: flex;\n  align-items: flex-start;\n  flex-direction: column;\n  margin-left: 6px;\n  min-width: 0;\n  flex-shrink: 0;\n}\n\n.webDownloadAppCardText1,\n.downloadAppCardText1 {\n  color: #444444;\n  font-family: \"Inter\", sans-serif;\n  font-size: 0.64rem;\n  font-weight: 500;\n  line-height: 1.1;\n  white-space: nowrap;\n}\n\n.webDownloadAppCardText2,\n.downloadAppCardText2 {\n  color: #111111;\n  font-family: \"Inter\", sans-serif;\n  font-size: 0.82rem;\n  font-weight: 700;\n  line-height: 1.2;\n  white-space: nowrap;\n}\n\n/* ==========================================================================\n   Responsive Media Queries\n   ========================================================================== */\n\n/* Medium / Narrow Desktops and Tablets in Landscape */\n@media (min-width: 769px) and (max-width: 1100px) {\n  .landingLeftSection {\n    width: 27%;\n    min-width: 260px;\n  }\n  .webDownloadAppCard,\n  .downloadAppCard {\n    padding: 4px 6px;\n  }\n  .webDownloadAppCardText2,\n  .downloadAppCardText2 {\n    font-size: 0.76rem;\n  }\n}\n\n/* Height-Constrained Laptops (e.g. 1366x768 with browser bars or scaled displays) */\n@media (max-height: 720px) {\n  .landingLeftSectionContainer {\n    height: 90vh;\n  }\n  .webAmalgamateLogo,\n  .amalgamateLogo {\n    max-height: 60px;\n  }\n  .leftSectionContentContainer {\n    gap: 16px;\n  }\n  .contentHeading {\n    font-size: 17px;\n    margin-bottom: 3px;\n  }\n  .contentTexts {\n    font-size: 13px;\n    line-height: 1.4;\n  }\n  .downloadAppCards {\n    margin-top: 10px;\n  }\n}\n\n/* Ultra-short screens (< 600px height) */\n@media (max-height: 600px) {\n  .landingLeftSectionContainer {\n    height: 94vh;\n  }\n  .webAmalgamateLogo,\n  .amalgamateLogo {\n    max-height: 48px;\n  }\n  .leftSectionContentContainer {\n    gap: 10px;\n  }\n  .contentHeading {\n    font-size: 15px;\n  }\n  .contentTexts {\n    font-size: 12px;\n    line-height: 1.3;\n  }\n}\n\n/* Mobile & Portrait Tablets */\n@media (max-width: 768px) {\n  .landingLeftSection {\n    display: none !important;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
